import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

/** 业务页缺少已选产品时的提示（平台管理员未选产品、或 session 缺失时） */
export function NoTenant() {
  const navigate = useNavigate();
  return (
    <Result
      status="info"
      title="请先选择产品"
      subTitle="业务数据按产品隔离，需先进入某个产品。"
      extra={
        <Button type="primary" onClick={() => navigate('/select-tenant')}>
          选择产品
        </Button>
      }
    />
  );
}
